<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{'Parameter'|translate}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field  class="mr-4" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Parameter')"><v-icon small class="mr-2">fa-plus</v-icon> {{'Add Record'|translate}}</v-btn>
                    <parameter-record-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></parameter-record-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="parameter"
                    class="elevation-1"
                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :items-per-page="25"
                    :search="search2"
            >
      <template v-slot:items="props">
        <td>{{ props.item.facility_name }}</td>
        <td class="text-xs-left">
            {{props.item.parameter_name}}
        </td>
        <td class="text-xs-left">{{ props.item.parameter_value }}</td>
        <td class="text-xs-left">{{ props.item.parameter_value_str}}</td>
        <td class="text-xs-left">{{ props.item.parameter_description }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            v-if="$can('update', 'Parameter')"
            @click="$can('update', 'Parameter') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            v-if="$can('update', 'Parameter')"
            @click="$can('update', 'Parameter') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getParameter, deleteParameter} from '../helper'
import ParameterRecordDialog from '../components/parameter/ParameterRecordDialog'

export default {
    name: 'Parameter',
  components: { ParameterRecordDialog },
  data(){
    return{
      dialog: false,
      headers: [
        {
          text: this.$options.filters.translate('Facility Name'),
          align: 'left',
          sortable: true,
          value: 'facility_name',
        },
        { text: this.$options.filters.translate('Parameter Name'), value: 'parameter_name' },
        { text: this.$options.filters.translate('Parameter Value'), value: 'parameter_value', sortable: false },
        { text: this.$options.filters.translate('Parameter Value Str'), value: 'parameter_value_str'},
        { text: this.$options.filters.translate('Parameter Description'), value: 'parameter_description', sortable: false},
        { text: this.$options.filters.translate('Actions'), sortable: false },
      ],
      parameter: [
        {
          'facility_name': 'Facility Name',
          'parameter_name': 'Parameter Name',
          'parameter_value': 'Parameter Value',
          'parameter_value_str': 'Parameter Value Str',
          'parameter_description': 'Parameter Description',
        },
      ],
      editedIndex: -1,
      editedItem: {
      },
      search: '',
      search2: ''
    }},
    watch: {
      dialog (newdialog ) {
        this.refresh()
      },
      search(){
        this.debounce(this.syncSearches,500);
      }
    },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.parameter.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.parameter.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.parameter.splice(index, 1)
          await deleteParameter({
            'parameter_id': item.parameter_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.parameter[this.editedIndex], this.editedItem)
        } else {
          this.parameter.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getParameter({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.parameter = df['result']
      },
      syncSearches(){
        this.search2=this.search
      },
      debounce(callback, wait) {
        clearTimeout(this.timeout);
        this.timeout= setTimeout(() => callback(), wait);
      },
    }
  }
</script>

<style scoped>

</style>
